/* NOOK Huonekaluliike — Theme JavaScript */

document.addEventListener('DOMContentLoaded', function () {

  // ── KEYBOARD PAGINATION (← previous page, → next page) ──
  // ── KEYBOARD NAVIGATION FOR PRODUCT LISTINGS ──
  //   ← / →  : previous / next page
  //   j / k  : next / previous product (Feedly/vim convention), Enter opens it
  // j/k hop across page boundaries; the #kb hash restores the cursor position.
  (function () {
    const grid = document.querySelector('.product-grid');
    const cards = grid ? Array.prototype.slice.call(grid.querySelectorAll('a.product-card')) : [];
    const pager = document.querySelector('[data-pagination]');
    const nextUrl = pager && pager.dataset.nextUrl;
    const prevUrl = pager && pager.dataset.prevUrl;
    if (!cards.length && !pager) return;

    let idx = -1;
    function highlight(i, smooth) {
      cards.forEach(function (c) { c.classList.remove('kb-active'); c.removeAttribute('aria-current'); });
      idx = Math.max(0, Math.min(cards.length - 1, i));
      const el = cards[idx];
      if (!el) return;
      el.classList.add('kb-active');
      el.setAttribute('aria-current', 'true');
      el.focus({ preventScroll: true });
      el.scrollIntoView({ block: 'center', behavior: smooth ? 'smooth' : 'auto' });
    }
    // Restore cursor after a j/k page hop.
    if (cards.length && location.hash === '#kb=first') highlight(0, false);
    else if (cards.length && location.hash === '#kb=last') highlight(cards.length - 1, false);
    if (location.hash.indexOf('#kb=') === 0) {
      history.replaceState(null, '', location.pathname + location.search);
    }

    function typing(t) {
      return t && (t.tagName === 'INPUT' || t.tagName === 'TEXTAREA' || t.tagName === 'SELECT' || t.isContentEditable);
    }
    function drawerOpen() {
      const d = document.getElementById('cart-drawer');
      return d && d.classList.contains('open');
    }

    document.addEventListener('keydown', function (e) {
      if (e.metaKey || e.ctrlKey || e.altKey) return;
      if (typing(e.target) || drawerOpen()) return;
      switch (e.key) {
        case 'ArrowRight':
          if (nextUrl) { e.preventDefault(); window.location.href = nextUrl; }
          break;
        case 'ArrowLeft':
          if (prevUrl) { e.preventDefault(); window.location.href = prevUrl; }
          break;
        case 'j':
          if (!cards.length) break;
          e.preventDefault();
          if (idx === -1) highlight(0, true);
          else if (idx >= cards.length - 1) { if (nextUrl) window.location.href = nextUrl + '#kb=first'; }
          else highlight(idx + 1, true);
          break;
        case 'k':
          if (!cards.length) break;
          e.preventDefault();
          if (idx <= 0) { if (idx === 0 && prevUrl) window.location.href = prevUrl + '#kb=last'; else highlight(0, true); }
          else highlight(idx - 1, true);
          break;
        case 'Enter':
          if (idx >= 0 && cards[idx]) window.location.href = cards[idx].href;
          break;
      }
    }, true);
  })();

  // ── CART DRAWER ──
  const cartOverlay = document.getElementById('cart-overlay');
  const cartDrawer = document.getElementById('cart-drawer');
  const cartOpenBtns = document.querySelectorAll('[data-cart-open]');
  const cartCloseBtns = document.querySelectorAll('[data-cart-close]');

  function openCart() {
    if (cartOverlay) cartOverlay.classList.add('open');
    if (cartDrawer) cartDrawer.classList.add('open');
    document.body.style.overflow = 'hidden';
  }

  function closeCart() {
    if (cartOverlay) cartOverlay.classList.remove('open');
    if (cartDrawer) cartDrawer.classList.remove('open');
    document.body.style.overflow = '';
  }

  cartOpenBtns.forEach(btn => btn.addEventListener('click', openCart));
  cartCloseBtns.forEach(btn => btn.addEventListener('click', closeCart));
  if (cartOverlay) cartOverlay.addEventListener('click', closeCart);

  // ── MOBILE MENU ──
  const mobileMenuBtn = document.getElementById('mobile-menu-btn');
  const mobileMenu = document.getElementById('mobile-menu');

  if (mobileMenuBtn && mobileMenu) {
    mobileMenuBtn.setAttribute('aria-expanded', 'false');
    mobileMenuBtn.setAttribute('aria-controls', 'mobile-menu');
    const setMenu = (open) => {
      mobileMenu.style.display = open ? 'block' : 'none';
      mobileMenu.classList.toggle('open', open);
      mobileMenuBtn.setAttribute('aria-expanded', String(open));
      // Lock the page behind the open menu (mirrors openCart/closeCart).
      document.body.style.overflow = open ? 'hidden' : '';
    };
    mobileMenuBtn.addEventListener('click', () => {
      setMenu(mobileMenu.style.display === 'none' || !mobileMenu.style.display);
    });
    // Close on Escape or when a link is followed.
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && mobileMenu.style.display === 'block') { setMenu(false); mobileMenuBtn.focus(); }
    });
    mobileMenu.addEventListener('click', (e) => { if (e.target.closest('a')) setMenu(false); });
  }

 // ── PRODUCT GALLERY THUMBS ──
  const thumbs = document.querySelectorAll('.product-gallery-thumbs .thumb');
  const mainImage = document.getElementById('main-product-image');

  // Arrows / ←→ step through the SAME thumb list, so all images are reachable
  // even when more than four exist (the strip scrolls the active one into view).
  const galleryStep = (dir) => {
    if (!thumbs.length) return;
    const list = Array.from(thumbs);
    let i = list.findIndex(t => t.classList.contains('active'));
    i = (i + dir + list.length) % list.length;
    list[i].click();
    list[i].scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });
  };
  document.querySelector('[data-gallery-prev]')?.addEventListener('click', () => galleryStep(-1));
  document.querySelector('[data-gallery-next]')?.addEventListener('click', () => galleryStep(1));
  const galleryMain = mainImage?.closest('.product-gallery-main');
  if (galleryMain && thumbs.length) {
    galleryMain.setAttribute('tabindex', '0');
    galleryMain.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowLeft') { e.preventDefault(); galleryStep(-1); }
      if (e.key === 'ArrowRight') { e.preventDefault(); galleryStep(1); }
    });
    // Swipe on touch
    let sx = null;
    galleryMain.addEventListener('touchstart', (e) => { sx = e.touches[0].clientX; }, { passive: true });
    galleryMain.addEventListener('touchend', (e) => {
      if (sx == null) return; const dx = e.changedTouches[0].clientX - sx; sx = null;
      if (Math.abs(dx) > 40) galleryStep(dx < 0 ? 1 : -1);
    }, { passive: true });
  }

  thumbs.forEach(thumb => {
    thumb.addEventListener('click', () => {
      thumbs.forEach(t => { t.classList.remove('active'); t.removeAttribute('aria-current'); });
      thumb.classList.add('active'); thumb.setAttribute('aria-current', 'true');
      const cnt = document.querySelector('[data-gallery-count]');
      if (cnt) cnt.textContent = (Array.from(thumbs).indexOf(thumb) + 1) + ' / ' + thumbs.length;
      if (mainImage) {
        const img = thumb.querySelector('img');
        const src = img?.dataset.full || img?.src;
        // Prefer the product page's helper (spinner + srcset clearing); fall back
        // to a plain swap if it isn't present.
        if (src && window.__swapMainImage) {
          window.__swapMainImage(src);
        } else if (src) {
          mainImage.removeAttribute('srcset');
          mainImage.removeAttribute('sizes');
          mainImage.src = src;
        }
      }
    });
  });
  // ── QTY SELECTOR ──
  document.querySelectorAll('.qty-selector').forEach(selector => {
    const input = selector.querySelector('.qty-input');
    const minus = selector.querySelector('[data-qty-minus]');
    const plus = selector.querySelector('[data-qty-plus]');

    if (minus) minus.addEventListener('click', () => {
      const val = parseInt(input.value) || 1;
      if (val > 1) input.value = val - 1;
    });

    if (plus) plus.addEventListener('click', () => {
      const val = parseInt(input.value) || 1;
      input.value = val + 1;
    });
  });

  // ── ANNOUNCEMENT BAR SCROLL HIDE ──
  const announcementBar = document.querySelector('.announcement-bar');
  let lastScroll = 0;

  window.addEventListener('scroll', () => {
    const currentScroll = window.pageYOffset;
    if (announcementBar) {
      if (currentScroll > lastScroll && currentScroll > 80) {
        announcementBar.style.transform = 'translateY(-100%)';
      } else {
        announcementBar.style.transform = 'translateY(0)';
      }
    }
    lastScroll = currentScroll;
  });

  // ── FADE IN ON SCROLL ──
  const observerOptions = { threshold: 0.1, rootMargin: '0px 0px -50px 0px' };

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('visible');
        observer.unobserve(entry.target);
      }
    });
  }, observerOptions);

  document.querySelectorAll('.scroll-reveal').forEach(el => {
    el.style.opacity = '0';
    el.style.transform = 'translateY(20px)';
    el.style.transition = 'opacity 0.6s ease, transform 0.6s ease';
    observer.observe(el);
  });

  // Add visible state
  document.head.insertAdjacentHTML('beforeend', `
    <style>
      .scroll-reveal.visible {
        opacity: 1 !important;
        transform: translateY(0) !important;
      }
    </style>
  `);

  // ── NEWSLETTER FORM ──
  // Posts natively to Shopify's customer endpoint (see sections/newsletter.liquid,
  // {% form 'customer' %}); success/error are rendered server-side. No JS interception
  // — the old handler faked success and discarded the address.

  // ── ADD TO CART (Shopify AJAX) ──
  const addToCartForm = document.getElementById('add-to-cart-form');
  if (addToCartForm) {
    addToCartForm.addEventListener('submit', async (e) => {
      e.preventDefault();
      const formData = new FormData(addToCartForm);
      const submitBtn = addToCartForm.querySelector('[type="submit"]');
      const originalText = submitBtn.textContent;

      submitBtn.textContent = 'Lisätään...';
      submitBtn.disabled = true;
      showAddToCartError('');

      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Accept': 'application/json' },
          body: formData
        });

        if (response.ok) {
          submitBtn.textContent = 'Lisätty ✓';
          setTimeout(() => {
            submitBtn.textContent = originalText;
            submitBtn.disabled = false;
            openCart();
            refreshCartDrawer();
          }, 1000);
        } else {
          // Shopify returns a JSON body with a Finnish-localised `description`
          // for out-of-stock, quantity limits, etc. Surface it instead of hanging.
          let msg = 'Tuotteen lisääminen ei onnistunut. Yritä uudelleen.';
          try {
            const body = await response.json();
            if (body && body.description) msg = body.description;
          } catch (_) { /* non-JSON error body */ }
          submitBtn.textContent = originalText;
          submitBtn.disabled = false;
          showAddToCartError(msg);
        }
      } catch (err) {
        submitBtn.textContent = originalText;
        submitBtn.disabled = false;
        showAddToCartError('Verkkovirhe — tarkista yhteytesi ja yritä uudelleen.');
      }
    });

    // Inline, screen-reader-announced error region next to the CTA.
    function showAddToCartError(msg) {
      let el = addToCartForm.querySelector('[data-atc-error]');
      if (!el) {
        el = document.createElement('p');
        el.setAttribute('data-atc-error', '');
        el.setAttribute('role', 'alert');
        el.className = 'atc-error';
        addToCartForm.appendChild(el);
      }
      el.textContent = msg || '';
      el.style.display = msg ? 'block' : 'none';
    }
  }

  // ── REFRESH CART DRAWER ──

  async function refreshCartDrawer() {
    const cart = await fetch('/cart.js').then(r => r.json());

    const money = c => (c / 100).toLocaleString('fi-FI', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €';
    const esc = s => String(s ?? '').replace(/&/g, '&amp;').replace(/</g, '&lt;');

   // Lukumäärä (yläpalkin pallukka + laatikon otsikko)
    document.querySelectorAll('[data-cart-count], .cart-count').forEach(el => {
      el.textContent = cart.item_count;
      if (el.hasAttribute('data-cart-count')) el.hidden = cart.item_count === 0;
    });

    // Tuotelista
    const itemsEl = document.getElementById('cart-items');
    if (itemsEl) {
      itemsEl.innerHTML = cart.items.map((item, i) => `
        <div style="display:flex; gap:12px; padding:12px 0; border-bottom:1px solid rgba(200,184,170,0.3); align-items:flex-start;">
          <a href="${item.url}">
            ${item.image ? `<img src="${item.image}" alt="${esc(item.product_title)}" style="width:64px; height:80px; object-fit:contain; background:#fff;">` : ''}
          </a>
          <div style="flex:1;">
            <a href="${item.url}" style="font-size:0.85rem; font-weight:500;">${esc(item.product_title)}</a>
            ${item.variant_title ? `<p style="font-size:0.75rem; color:#6e635b; margin-top:2px;">${esc(item.variant_title)}</p>` : ''}
            <div style="display:flex; justify-content:space-between; align-items:center; margin-top:6px; font-size:0.8rem;">
              <span>${item.quantity} × ${money(item.price)}</span>
              <button type="button" data-remove-line="${i + 1}" style="background:none; border:none; font-size:0.72rem; color:#6e635b; text-decoration:underline; cursor:pointer;">Poista</button>
            </div>
          </div>
        </div>`).join('');

      itemsEl.querySelectorAll('[data-remove-line]').forEach(btn => {
        btn.addEventListener('click', async () => {
          await fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ line: Number(btn.dataset.removeLine), quantity: 0 })
          });
          refreshCartDrawer();
        });
      });
    }

// Yhteensä
    const totalEl = document.querySelector('#cart-drawer .cart-total span:last-child');
    if (totalEl) totalEl.textContent = money(cart.total_price);
  }

  refreshCartDrawer();
  window.openCart = openCart;
  window.refreshCartDrawer = refreshCartDrawer;

});

// ── "MAHTUUKO AUTOOSI?" — compare the package's longest side to a few presets ──
(function () {
  function initCarFit() {
    document.querySelectorAll('.car-fit').forEach(function (box) {
      if (box.dataset.done) return;
      box.dataset.done = '1';
      var ul = box.querySelector('.car-fit-list');
      if (!ul) return;
      var presets = [
        { label: 'Farmariauton takaluukku', cm: 180 },
        { label: 'Henkilöauton takakontti', cm: 105 },
        { label: 'Vakio-oviaukko', cm: 80 }
      ];
      // Whether a package passes through an opening is governed by its TWO SMALLER
      // dimensions (the long axis goes inward), so the limiting size is the MIDDLE
      // of the three sorted dims — not the longest side.
      var dims = ['l', 'w', 'h']
        .map(function (k) { return parseFloat(box.dataset[k]); })
        .filter(function (n) { return !isNaN(n) && n > 0; })
        .sort(function (a, b) { return a - b; });
      var longest = parseFloat(box.dataset.longest);
      if (dims.length === 3) {
        var limiting = dims[1]; // second-smallest = the constraining cross-section
        ul.innerHTML = presets.map(function (p) {
          var ok = limiting <= p.cm;
          return '<li class="' + (ok ? 'fit-yes' : 'fit-no') + '"><span class="fit-ico" aria-hidden="true">' +
            (ok ? '✓' : '✗') + '</span>' + p.label + ' <span class="fit-cm">(' + p.cm + ' cm)</span></li>';
        }).join('');
      } else if (!isNaN(longest) && longest > 0) {
        // Only the longest side is known: we can confirm a fit when even that fits,
        // but can't rule one out (cross-section unknown) — so show a soft "maybe".
        ul.innerHTML = presets.map(function (p) {
          var ok = longest <= p.cm;
          return '<li class="' + (ok ? 'fit-yes' : 'fit-maybe') + '"><span class="fit-ico" aria-hidden="true">' +
            (ok ? '✓' : '?') + '</span>' + p.label + ' <span class="fit-cm">(' + p.cm + ' cm)</span></li>';
        }).join('');
      } else {
        var fits = box.dataset.fits === 'true';
        ul.innerHTML = '<li class="' + (fits ? 'fit-yes' : 'fit-no') + '"><span class="fit-ico" aria-hidden="true">' +
          (fits ? '✓' : '✗') + '</span>' +
          (fits ? 'Mahtuu tavalliseen farmariautoon (taitettuna)' : 'Suosittelemme rahtitoimitusta') + '</li>';
      }
    });
  }
  if (document.readyState !== 'loading') initCarFit();
  else document.addEventListener('DOMContentLoaded', initCarFit);
})();

// ── COLLECTION FILTERS — sort (preserving filters), mobile drawer, auto-apply ──
(function () {
  function initCollection() {
    var sort = document.getElementById('collection-sort');
    if (sort) {
      if (sort.dataset.current) sort.value = sort.dataset.current;
      sort.addEventListener('change', function () {
        var u = new URL(location.href);
        u.searchParams.set('sort_by', sort.value);
        u.searchParams.delete('page');
        location.href = u.toString();
      });
    }
    // Auto-apply the filter form on any change (checkbox toggle / price entry).
    var form = document.getElementById('CollectionFilterForm');
    if (form) form.addEventListener('change', function () { form.submit(); });

    // Mobile filter drawer.
    var panel = document.querySelector('[data-filter-panel]');
    var overlay = document.querySelector('[data-filter-overlay]');
    var openBtn = document.querySelector('[data-filter-open]');
    function setOpen(on) {
      if (!panel) return;
      panel.classList.toggle('is-open', on);
      if (overlay) overlay.hidden = !on;
      if (openBtn) openBtn.setAttribute('aria-expanded', String(on));
      document.body.style.overflow = on ? 'hidden' : '';
    }
    if (openBtn) openBtn.addEventListener('click', function () { setOpen(true); });
    document.querySelectorAll('[data-filter-close]').forEach(function (b) {
      b.addEventListener('click', function () { setOpen(false); });
    });
    if (overlay) overlay.addEventListener('click', function () { setOpen(false); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') setOpen(false); });
  }
  if (document.readyState !== 'loading') initCollection();
  else document.addEventListener('DOMContentLoaded', initCollection);
})();

// ── "MAHTUUKO TILAAN?" — client-side dimension range filter over the shown grid ──
(function () {
  function cardDims(card) {
    var widths = [], lengths = [];
    if (card.dataset.sizes) {
      try {
        JSON.parse(card.dataset.sizes).forEach(function (s) {
          var m = String(s).replace(/ø/gi, '').match(/(\d+(?:[.,]\d+)?)\s*x\s*(\d+(?:[.,]\d+)?)/i);
          if (m) { widths.push(parseFloat(m[1].replace(',', '.'))); lengths.push(parseFloat(m[2].replace(',', '.'))); }
        });
      } catch (e) {}
    }
    var w = parseFloat(card.dataset.w), l = parseFloat(card.dataset.l), h = parseFloat(card.dataset.h);
    if (!isNaN(w)) widths.push(w);
    if (!isNaN(l)) lengths.push(l);
    return {
      w: widths.length ? [Math.min.apply(null, widths), Math.max.apply(null, widths)] : null,
      d: lengths.length ? [Math.min.apply(null, lengths), Math.max.apply(null, lengths)] : null,
      h: !isNaN(h) ? [h, h] : null
    };
  }
  function apply(panel, grid) {
    var cons = {};
    ['w', 'd', 'h'].forEach(function (k) {
      var mn = parseFloat(panel.querySelector('[data-dim-min="' + k + '"]').value);
      var mx = parseFloat(panel.querySelector('[data-dim-max="' + k + '"]').value);
      if (!isNaN(mn) || !isNaN(mx)) cons[k] = [isNaN(mn) ? 0 : mn, isNaN(mx) ? Infinity : mx];
    });
    var active = Object.keys(cons).length > 0, shown = 0, total = 0;
    grid.querySelectorAll('.product-card').forEach(function (card) {
      total++;
      if (!active) { card.style.display = ''; shown++; return; }
      var d = cardDims(card), ok = true;
      for (var k in cons) {
        var range = d[k];
        if (!range || !(range[0] <= cons[k][1] && range[1] >= cons[k][0])) { ok = false; break; }
      }
      card.style.display = ok ? '' : 'none';
      if (ok) shown++;
    });
    var c = panel.querySelector('[data-dimfit-count]');
    if (c) c.textContent = active ? (shown + ' / ' + total + ' tuotetta täsmää') : '';
  }
  function init() {
    var panel = document.querySelector('[data-dimfit]');
    var grid = document.querySelector('[data-product-grid]');
    if (!panel || !grid) return;
    var run = function () { apply(panel, grid); };
    panel.addEventListener('input', run);
    var clear = panel.querySelector('[data-dimfit-clear]');
    if (clear) clear.addEventListener('click', function () {
      panel.querySelectorAll('input[type="number"]').forEach(function (i) { i.value = ''; });
      run();
    });
    // Re-filter whenever more products are appended.
    document.addEventListener('products:loaded', run);
    // Opening the tool loads the WHOLE category (where 'Näytä kaikki' exists — not
    // /collections/all) so the filter spans every page; then paging is retired.
    panel.addEventListener('toggle', function () {
      if (panel.open && window.__loadAllProducts && window.__hasMore && window.__hasMore()) {
        var c = panel.querySelector('[data-dimfit-count]'); if (c) c.textContent = 'Ladataan koko valikoima…';
        var nav = document.querySelector('.pagination-wrap'); if (nav) nav.style.display = 'none';
        window.__loadAllProducts().then(run);
      }
    });
  }
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();

// ── LOAD MORE / SHOW ALL — append further pages so filters see the whole collection ──
(function () {
  var box, grid, nextUrl, total, loading = false;
  function status(msg) { var s = box && box.querySelector('[data-loadmore-status]'); if (s) s.textContent = msg || ''; }
  function count() { return grid ? grid.querySelectorAll('.product-card').length : 0; }
  function fetchNext() {
    if (!nextUrl || loading) return Promise.resolve(false);
    loading = true;
    var url = nextUrl;
    return fetch(url).then(function (r) { return r.text(); }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      doc.querySelectorAll('[data-product-grid] .product-card').forEach(function (c) {
        grid.appendChild(document.importNode(c, true));
      });
      var lm = doc.querySelector('[data-loadmore]');
      nextUrl = lm ? lm.getAttribute('data-next-url') : null;
      document.dispatchEvent(new CustomEvent('products:loaded'));
      return !!nextUrl;
    }).catch(function () { return false; }).then(function (more) { loading = false; return more; });
  }
  // If we're on page 2+, the grid only holds that page — page 1 is missing, so a
  // client-side dimension filter over "everything" would silently drop the first
  // page. Reset to page 1 and reload the whole set forward from there.
  var resetDone = false;
  function currentPageNum() {
    var m = /[?&]page=(\d+)/.exec(location.search);
    return m ? parseInt(m[1], 10) : 1;
  }
  function firstPageUrl() {
    try {
      var u = new URL(location.href);
      u.searchParams.delete('page');
      return u.pathname + u.search;
    } catch (_) { return location.pathname; }
  }
  function ensureFromStart() {
    if (resetDone) return;
    resetDone = true;
    if (currentPageNum() > 1) {
      grid.innerHTML = '';
      nextUrl = firstPageUrl();
    }
  }
  function loadAll(max) {
    max = max || 20;
    ensureFromStart();
    var pages = 0;
    function step() {
      if (!nextUrl || pages >= max) { status(nextUrl ? (count() + ' ladattu') : ''); return Promise.resolve(); }
      status('Ladataan… (' + count() + ' / ' + total + ')');
      pages++;
      return fetchNext().then(step);
    }
    return step();
  }
  function init() {
    box = document.querySelector('[data-loadmore]');
    grid = document.querySelector('[data-product-grid]');
    if (!box || !grid) return;
    nextUrl = box.getAttribute('data-next-url');
    total = box.getAttribute('data-total');
    // Numbered pagination stays visible — it's the default browsing UX.
    // /collections/all has no button (data-no-button); the box only feeds search.
    var btn = box.querySelector('[data-loadmore-all]');
    if (!box.hasAttribute('data-no-button')) box.hidden = false;
    if (btn) btn.addEventListener('click', function () {
      var nav = document.querySelector('.pagination-wrap'); if (nav) nav.style.display = 'none';
      loadAll().then(function () { if (!nextUrl) box.hidden = true; });
    });
    window.__loadAllProducts = function (max) {
      return loadAll(max).then(function () { if (!nextUrl) box.hidden = true; });
    };
    window.__hasMore = function () { return !!nextUrl; };
  }
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();

// ── COLLECTION SEARCH — free-text filter over the open collection ──
// Cards carry data-q (title + type) and data-qx (tags, SKUs, variant names;
// collection.liquid). A query word matches anywhere inside a title/type word
// (Finnish compounds: "pöytä" → "sivupöytä") but only at the START of a word in
// data-qx, and a number only as a whole number ("180" ↔ "180x200") — otherwise
// "eden 9" hits "sweden" tags, "90x200" sizes and SKU digits.
// The first query loads the rest of the collection (same loader as "Näytä
// kaikki"), then non-matching cards are hidden via [data-qhide] so this ANDs with
// the "Mahtuuko tilaan?" filter, which uses inline display. Accent-insensitive:
// "poyta" finds "pöytä". ?q= in the URL is kept in sync and restored on load.
(function () {
  function norm(s) {
    return String(s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '');
  }
  function init() {
    var form = document.querySelector('[data-collection-search]');
    var grid = document.querySelector('[data-product-grid]');
    if (!form || !grid) return;
    var input = form.querySelector('input[name="q"]');
    var statusEl = document.querySelector('[data-collection-search-status]');
    var nav = document.querySelector('.pagination-wrap');
    var loaded = false, loadingAll = null, timer = null;

    function setStatus(html) {
      if (!statusEl) return;
      statusEl.innerHTML = html || '';
      statusEl.hidden = !html;
    }
    function syncUrl(q) {
      try {
        var u = new URL(location.href);
        if (q) { u.searchParams.set('q', q); u.searchParams.delete('page'); } else u.searchParams.delete('q');
        history.replaceState(history.state, '', u.pathname + u.search + u.hash);
      } catch (_) {}
    }
    function ensureAll() {
      if (loaded) return Promise.resolve();
      if (loadingAll) return loadingAll;
      if (!(window.__loadAllProducts && window.__hasMore && window.__hasMore())) { loaded = true; return Promise.resolve(); }
      if (nav) nav.style.display = 'none';
      loadingAll = window.__loadAllProducts(40).then(function () { loaded = true; loadingAll = null; });
      return loadingAll;
    }
    function filter() {
      var raw = input.value.trim();
      var words = norm(raw).replace(/[^a-z0-9]+/g, ' ').split(' ').filter(Boolean);
      var shown = 0;
      grid.querySelectorAll('.product-card').forEach(function (card) {
        if (!card.__q) {
          card.__q = ' ' + norm(card.getAttribute('data-q') || card.textContent).replace(/[^a-z0-9]+/g, ' ') + ' ';
          card.__qx = ' ' + norm(card.getAttribute('data-qx')).replace(/[^a-z0-9]+/g, ' ') + ' ';
        }
        var ok = words.every(function (w) {
          var start = ' ' + w;
          if (/^\d+$/.test(w)) { var tok = start + ' '; return card.__q.indexOf(tok) !== -1 || card.__qx.indexOf(tok) !== -1; }
          return card.__q.indexOf(w) !== -1 || card.__qx.indexOf(start) !== -1;
        });
        if (ok) { card.removeAttribute('data-qhide'); if (card.style.display !== 'none') shown++; }
        else card.setAttribute('data-qhide', '');
      });
      if (!words.length) { setStatus(''); if (nav && !loaded) nav.style.display = ''; return; }
      var esc = raw.replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; });
      if (loadingAll) { setStatus(shown + ' osumaa — haetaan koko kokoelmasta…'); return; }
      setStatus(shown
        ? shown + ' tuotetta haulla ”' + esc + '”'
        : 'Ei osumia haulla ”' + esc + '” tässä kokoelmassa. <a href="' + form.getAttribute('action') + '?type=product&options%5Bprefix%5D=last&q=' + encodeURIComponent(raw) + '">Hae koko kaupasta</a>');
    }
    function run() {
      var q = input.value.trim();
      syncUrl(q);
      if (!q) { filter(); return; }
      ensureAll().then(filter);
      filter(); // instant feedback on the cards already on the page
    }
    input.addEventListener('input', function () { clearTimeout(timer); timer = setTimeout(run, 200); });
    form.addEventListener('submit', function (e) { e.preventDefault(); clearTimeout(timer); run(); });
    input.addEventListener('keydown', function (e) { if (e.key === 'Escape' && input.value) { input.value = ''; run(); } });
    document.addEventListener('products:loaded', function () { if (input.value.trim()) filter(); });

    var initial = new URLSearchParams(location.search).get('q');
    if (initial) { input.value = initial; run(); }
  }
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
